/**
 * Utility functions for Meta tracking
 */

/**
 * Checks if the cookies for excluding tracking are present
 * @returns {boolean} True if tracking is opted out based on cookies
 */
export function hasOptedOutOfTrackingCookie() {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    const cookies = {};
    
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        const cookieParts = cookie.split("=");
        const cookieName = cookieParts[0];
        const cookieValue = cookieParts[1];
        cookies[cookieName] = cookieValue;
    }
    
    const cookieValuesToCheck = {
        "trustarc_gpc_has_submitted_form": "form-opened_submitted",
        "notice_preferences": "0:"
    };
    
    for (const cookieName in cookieValuesToCheck) {
        if (cookieValuesToCheck.hasOwnProperty(cookieName) && 
            cookies[cookieName] === cookieValuesToCheck[cookieName]) {
            return true;
        }
    }
    return false;
}

export default {
    hasOptedOutOfTrackingCookie
};
